import { render, staticRenderFns } from "./EditCourseUnit.vue?vue&type=template&id=31163144&scoped=true&"
import script from "./EditCourseUnit.vue?vue&type=script&lang=js&"
export * from "./EditCourseUnit.vue?vue&type=script&lang=js&"
import style0 from "./EditCourseUnit.vue?vue&type=style&index=0&id=31163144&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31163144",
  null
  
)

export default component.exports